import React from 'react';
import ChatComponent from '../chat/chat';
import useTicketPage from '../hooks/ticket-page-hook';

const TicketPage = () => {
    const ticketHook = useTicketPage();

    return (
        <ChatComponent
            chatInfo={ticketHook?.ticketInfo}
            userInfo={ticketHook?.userInfo}
            totalPages={ticketHook?.ticketTotalPages}
            loadingMessages={ticketHook?.loadingMessages}
            isSendingMessage={ticketHook?.isSendingMessage}
            isMessageError={ticketHook?.isMessageError}
            setIsMessageError={ticketHook?.setIsMessageError}
            sentMessage={ticketHook?.sentMessage}
            fileUploadUrl={
                import.meta.env.VITE_APP_API_URL + 'tickets/attachments'
            }
            inputProps={{
                placeHolderText: 'پیام خود را وارد کنید...',
                validLength: [0, 500],
            }}
            maxLength={500}
            fileSizeLimit={ticketHook?.fileSizeLimit}
            onSend={ticketHook?.onSend}
            onResend={ticketHook?.onResend}
            onCancel={ticketHook?.onCancel}
            onPaginate={ticketHook?.onPaginate}
            onSatisfaction={ticketHook?.onSatisfaction}
            onErrorFile={ticketHook?.onErrorFile}
            onRefetchInfo={ticketHook?.onRefetchInfo}
        />
    );
};

export default TicketPage;
